import React from "react";
import { Stack } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { useGetFinancialPeriods } from "../../hooks/react-query/useFinancialsData";
import FinancialsContextMenu from "./FinancialsContextMenu";
import { items, getKeys } from "./helper";

export const FinancialsTable = ({ defaultLocation }) => {
  const { data, isLoading } = useGetFinancialPeriods({
    locationId: defaultLocation,
  });

  const keys = getKeys();

  return (
    <Stack flex={1} overflow="hidden">
      <HubTableTemplate
        id="FinancialsTable"
        headerProps={{ items, includeEnd: true }}
        bodyProps={{
          items: data || [],
          keys,
          ContextMenu: FinancialsContextMenu,
        }}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default FinancialsTable;
